var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureStatsSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.44 0c-.452 0-.854.288-.998.716L.055 19.614A1.05 1.05 0 0 0 1.051 21h5.14c.451 0 .852-.287.997-.715L14.043 0H7.439z",
    id: "ppode5vxea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.438.73.062 19.596a1.048 1.048 0 0 0 .634 1.34c.114.042.235.063.357.062h5.272c.4-.07.73-.352.865-.734l1.271-3.743 4.542 4.231c.19.158.43.244.676.246h5.908l-2.591-7.394-7.553.002L14.066 0H7.434c-.455 0-.858.295-.996.73",
    id: "2028vk5p1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36 0H0c.451 0 .852.287.996.714l6.387 18.9A1.052 1.052 0 0 1 6.387 21h7.36a1.048 1.048 0 0 0 .996-1.386L8.356.714A1.051 1.051 0 0 0 7.36 0",
    id: "wut468w1ff"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.995%",
    y1: "7.411%",
    x2: "37.157%",
    y2: "103.762%",
    id: "0lozsgc07b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11498A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0569BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.411%",
    y1: "4.512%",
    x2: "62.671%",
    y2: "99.892%",
    id: "yq8u3amedg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BCAF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2891DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.46 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qq62u7uwyc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ppode5vxea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.44 0c-.452 0-.854.288-.998.716L.055 19.614A1.05 1.05 0 0 0 1.051 21h5.14c.451 0 .852-.287.997-.715L14.043 0H7.439z",
    fill: "url(#0lozsgc07b)",
    mask: "url(#qq62u7uwyc)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.495 14.606H8.023a.484.484 0 0 0-.33.838l6.728 6.272c.196.182.454.284.722.284h5.929l-2.577-7.394z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.46 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rjctzftjle",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2028vk5p1d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.438.73.062 19.596a1.048 1.048 0 0 0 .634 1.34c.114.042.235.063.357.062h5.272c.4-.07.73-.352.865-.734l1.271-3.743 4.542 4.231c.19.158.43.244.676.246h5.908l-2.591-7.394-7.553.002L14.066 0H7.434c-.455 0-.858.295-.996.73",
    mask: "url(#rjctzftjle)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.977 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m8wx0qeaxh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wut468w1ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.36 0H0c.451 0 .852.287.996.714l6.387 18.9A1.052 1.052 0 0 1 6.387 21h7.36a1.048 1.048 0 0 0 .996-1.386L8.356.714A1.051 1.051 0 0 0 7.36 0",
    fill: "url(#yq8u3amedg)",
    mask: "url(#m8wx0qeaxh)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureStatsSection);
export default __webpack_public_path__ + "static/media/azure-stats-section.040162b8.svg";
export { ForwardRef as ReactComponent };